import { Box, TextField, Typography, useTheme } from '@material-ui/core';
import { TranslatedTextV2 } from 'components/atoms/TranslatedText';
import { useDispatch } from 'react-redux';
import { ITabContentProps, PropertyFilterType } from '../configuration';
import ProductFilterActions from '../store/actions';
import useStyles from '../styles';

const TabPropertyID = (props: ITabContentProps) => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const classes = useStyles();
  const onValueChange = (key: string, value: string | null) => {
    if (value === 'null') value = null;
    dispatch(
      ProductFilterActions.setFiltersSelectionAction({
        ...props.selections,
        [PropertyFilterType.PropertyID]: {
          ...props.selections[PropertyFilterType.PropertyID],
          isChecked: !!value,
          data: {
            ...props.selections[PropertyFilterType.PropertyID].data,
            [key]: value ? [parseInt(value)] : null,
          },
        },
      })
    );
  };
  return (
    <Box>
      <Typography
        style={{
          fontWeight: 700,
          fontSize: '16px',
          lineHeight: '20px',
          marginBottom: '4px',
        }}
      >
        <TranslatedTextV2 translationKey={''} defaultText={'Property ID'} />
      </Typography>
      <Typography
        style={{
          fontWeight: 400,
          fontSize: '12px',
          lineHeight: '16px',
          color: theme.palette.text.secondary,
          marginBottom: '18px',
        }}
      >
        <TranslatedTextV2
          translationKey={''}
          defaultText={'Please enter information'}
        />
      </Typography>
      <TextField
        onChange={(e) => onValueChange('ids', e.target.value)}
        value={
          props.selections[PropertyFilterType.PropertyID].data.ids?.[0] || ''
        }
        variant="outlined"
        type="number"
        inputMode="decimal"
        className={classes.boxInput}
      />
    </Box>
  );
};

export default TabPropertyID;
